import { Opportunity, CustomGetOpportunityQuery, useCustomGetOpportunityQuery } from "generated/graphql";
import { useCallback, useMemo } from "react";
type OpportunityForUpdate = NonNullable<CustomGetOpportunityQuery["getOpportunity"]>;

export const useGetOpportunity = ({ id }: { id: Opportunity["id"] }) => {
  const {
    loading,
    error,
    data: graphqlData,
  } = useCustomGetOpportunityQuery({
    variables: {
      id,
    },
  });

  const getData = useCallback(({ data }: { data: CustomGetOpportunityQuery }) => {
    return data?.getOpportunity || null;
  }, []);

  const data = useMemo(() => {
    return getData({ data: graphqlData }) as OpportunityForUpdate | null;
  }, [graphqlData]);

  return { loading, error, data, getData };
};
